window.tab=function(name){
    $(".nav li").removeClass("focus").eq(name).addClass("focus");
    $(".introduce_list").hide().eq(name).show();
    oIntroduce=name;
};

var oIntroduce=0;
$(".icon-arrow_right").click(function(){
    if(oIntroduce<3){
        if(!$(".introduce_list").is(":animated")){
            oIntroduce++;
            tab(oIntroduce)
        }
    }
});

$(".icon-arrow_left").click(function(){
    if(oIntroduce>0){
        if(!$(".introduce_list").is(":animated")){
            oIntroduce--;
            tab(oIntroduce)
        }
    }
});

$(".showTips").hover(function(){
    $(this).find("img").show()
},function(){
    $(this).find("img").hide()
})